<template>
  <ContextMenu v-bind="$attrs">
    <template
      v-for="(_, name) in $slots"
      #[name]
    >
      <slot :name="name" />
    </template>
  </ContextMenu>
</template>

<script lang="ts" setup>
  import ContextMenu from '@devhacker/shared/components/ContextMenu.vue';
</script>
